import * as React from 'react';
import { BetslipMultibetItem } from './BetslipMultibetItem';
import { useState } from 'react';
import { observable, action, makeObservable } from 'mobx';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/appState/AppState';
import { TrashIconWrapper } from 'src/domains/sportsbook/betting/ui/betSlip/betslipSelection/BetslipSelection.style';
import { BetslipMultibetId } from 'src/domains/sportsbook/betting/models/BetslipIdModels';
import {
    BetslipYouDecideWrapper,
    BetslipYouDecideLabel,
    BetslipYouDecideLabelEvent,
    CloseIcon,
    ChevronIconWrapper,
} from 'src/domains/sportsbook/betting/ui/betSlip/BetslipShared.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

class BetslipMultibetState {
    @observable public isVisible = true;

    @action public toggleVisibility = (): void => {
        this.isVisible = !this.isVisible;
    };

    public constructor() {
        makeObservable(this);
    }
}

interface PropsType {
    multibetSelectionId: BetslipMultibetId;
}

export const BetslipMultibet = observer('BetslipMultibet', (props: PropsType) => {
    const { appSportsBookState } = useAppStateContext();
    const { betSlipState, multibet } = appSportsBookState;
    const common = useCommon();
    const configComponents = ConfigComponents.get(common);
    const { config } = configComponents;

    const { multibetSelectionId } = props;

    const { clearError } = betSlipState.betSlipSummaryState;
    const [state] = useState(() => new BetslipMultibetState());

    const handleDeleteMultibet = (): void => {
        multibet.removeFromBetslip(multibetSelectionId);
        clearError();
    };

    const activeBets = multibet.activeBets;

    if (activeBets.length === 0) {
        return null;
    }
    const model = multibetSelectionId.getModel();

    const eventName = model.eventName;

    return (
        <BetslipYouDecideWrapper
            className='BetslipMultibet'
            data-test='betslip-multibet-section'
        >
            <BetslipYouDecideLabel
                onClick={state.toggleVisibility}
                data-test='betslip-bet-builder-header'
            >
                <ChevronIconWrapper position={state.isVisible ? 'down' : 'right'} />

                {config.rabHeaderTitle}
            </BetslipYouDecideLabel>
            <BetslipYouDecideLabelEvent data-test='event-name'>{eventName}</BetslipYouDecideLabelEvent>

            <CloseIcon
                /* eslint-disable-next-line */
                onClick={handleDeleteMultibet}
            >
                <TrashIconWrapper />
            </CloseIcon>

            {state.isVisible ? (
                <BetslipMultibetItem
                    className='x-BetslipMultibetItem'
                    key={model.fixtureId}
                    multibetSelectionId={model.id}
                />
            ) : null}
        </BetslipYouDecideWrapper>
    );
});
